import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import AppHistory from "shared/history"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import propTypesExact from "prop-types-exact"
import React from "react"
import {SegmentedButtons} from "react-native-paper"

/**
 * @typedef {object} ComponentsAdminNavSegmentedProps
 * @property {unknown} active
 * @property {unknown} buttons
 * @property {unknown} dataSet
 * @property {unknown} style
 * @property {unknown} testID
 */

/** @typedef {object} ComponentsAdminNavSegmentedState */

/**
 * @extends {ShapeComponent<ComponentsAdminNavSegmentedProps, ComponentsAdminNavSegmentedState>}
 */
class ComponentsAdminNavSegmented extends ShapeComponent {
  static defaultProps = {
    testID: undefined
  }

  static propTypes = propTypesExact({
    active: PropTypes.string.isRequired,
    buttons: PropTypes.array.isRequired,
    dataSet: PropTypes.object,
    style: PropTypes.object,
    testID: PropTypes.string
  })

  render() {
    const {active, buttons} = this.p
    const {dataSet, style, testID} = this.props
    const actualDataSet = Object.assign(
      {component: "admin--nav-segmented"},
      dataSet
    )

    return (
      <SegmentedButtons
        buttons={buttons.map((button) => ({label: button.label, testID: button.value, value: button.value}))}
        dataSet={actualDataSet}
        onValueChange={this.tt.onValueChange}
        style={style}
        testID={testID}
        value={active}
      />
    )
  }

  onValueChange = (newValue) => {
    const activeButton = this.p.buttons.find((button) => button.value == newValue)

    AppHistory.push(activeButton.to)
  }
}

export default memo(shapeComponent(ComponentsAdminNavSegmented))
